module.exports = __webpack_public_path__ + "media/images/weather/214_day-21b627084b467ff5509eac948634d417.png";